import React, { useCallback } from 'react';
import FormSubmitAction from '..';
import { useShouldRenderBlueprint } from '../../../../common/useShouldRenderBlueprint';
import { MODE } from '../../../../constants';
import { useFormSubmitterContext } from '../../form-submitter-context';
import {
  ACTION_SIMULATE_SUBMIT,
  ACTION_SUBMIT,
  ACTION_TOGGLE_TOS_CHECKBOX,
} from '../../form-submitter-context/form-submitter-constant';
import { useSplitTreatment } from '../../../../common/split-treatment';
import { FEATURE_FLAGS } from '../../../../constants/feature-flags';

const FormSubmitActionWithContext = () => {
  const {
    state,
    dispatch,
    selector: { getTosChecked },
  } = useFormSubmitterContext();
  const {
    submitInProgress,
    submissionFailed,
    form: { formType },
    isPreview,
    isAuthenticationRequired,
  } = state;

  const isFileRequestPreview = formType === MODE.FILE_REQUEST && isPreview;
  const isFormPreview = formType === MODE.FORM && isPreview;

  const submitForm = useCallback(() => {
    dispatch({
      type: ACTION_SUBMIT,
    });
  }, [dispatch]);

  const simulateSubmitForm = useCallback(() => {
    dispatch({
      type: ACTION_SIMULATE_SUBMIT,
    });
  }, [dispatch]);

  const handleTosAcceptanceChange = useCallback(() => {
    dispatch({ type: ACTION_TOGGLE_TOS_CHECKBOX });
  }, [dispatch]);

  const isFormsTOSEnabled = useSplitTreatment(FEATURE_FLAGS.FORMS_TOS);
  // Should be addressed in FORMS-21231
  const shouldRenderBlueprint = useShouldRenderBlueprint();
  const showTOSFooter =
    isFormsTOSEnabled && !isAuthenticationRequired && formType === MODE.FORM;

  return (
    <FormSubmitAction
      displayNewSubmitterDesign={shouldRenderBlueprint}
      isAuthenticationRequired={isAuthenticationRequired}
      isDisabled={isFileRequestPreview}
      onSubmit={isFormPreview ? simulateSubmitForm : submitForm}
      submissionFailed={submissionFailed}
      submitInProgress={submitInProgress}
      showTOSFooter={showTOSFooter}
      tosAcceptanceChecked={!!getTosChecked(state)}
      handleTosAcceptanceChange={handleTosAcceptanceChange}
    />
  );
};

export { FormSubmitActionWithContext };
export default FormSubmitActionWithContext;
